import {
  ReportType,
  type Report,
} from '@/shared/api/protocol-ts/model/dto_report_pb';

export const getReportContextLabel = (report: Report) => {
  const type = (ReportType[report.Type] ?? '')
    .replace(/^ReportType_/, '')
    .replaceAll('_', ' ');
  const date = report.Created?.At?.toDate().toISOString().split('T')[0];
  return [type, date].filter(Boolean).join(' ');
};
